// src/pages/admin/IntegrationAppDialog.tsx
import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";

import { Save, Plus, X } from "lucide-react"; 
import { IconTextButton } from "../../components/ButtonComponents";
import { IntegrationApplication } from "../../types/integration";

interface IntegrationAppDialogProps {
  isOpen: boolean;
  onClose: () => void;
  app: IntegrationApplication | null;
  onSave: (data: any) => void;
}

// Prisma'da tanımladığımız IntegrationType Enum değerleri
const integrationTypeOptions = [
  { label: "Mikro v16", value: "MIKROV16" },
    { label: "Mikro v17", value: "MIKROV17" }, 
  { label: "Netsis", value: "NETSIS" },
  { label: "E-Ticaret (Genel)", value: "E_COMMERCE" },
    { label: "Zirve", value: "ZIRVE" },
  { label: "Özel Entegrasyon", value: "CUSTOM" },
];  

const initialData = {
  name: "",
  externalType: "MIKROV16",
  isActive: true,
};

export const IntegrationAppDialog: React.FC<IntegrationAppDialogProps> = ({
  isOpen,
  onClose,
  app,
  onSave,
}) => {
  const [formData, setFormData] = useState(initialData);

  // dialog açıldığında form doldur
  useEffect(() => {
    if (!isOpen) return;

    if (app) {
      setFormData({
        name: app.name,
        externalType: app.externalType,
        isActive: app.isActive,
      });
    } else {
      setFormData(initialData);
    }
  }, [app, isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name || !formData.externalType) {
      console.error("Lütfen tüm zorunlu alanları doldurun.");
      return;
    }

    onSave(formData);
  };

  return (
    <Dialog
      header={app ? "Uygulama Tanımı Düzenle" : "Yeni Uygulama Tanımı"}
      visible={isOpen}
      onHide={onClose}
      modal
        maximizable
      resizable={false}
      className="w-full md:w-6/12"
      footer={
        <div className="flex justify-end gap-3">
          <IconTextButton onClick={onClose} icon={X} className="btn-cancel">
            İptal
          </IconTextButton>

          <IconTextButton
            onClick={handleSubmit}
            icon={app ? Save : Plus}
            className="btn-new"
          >
            {app ? "Güncelle" : "Ekle"}
          </IconTextButton>
        </div>
      }
    >
      <div className="space-y-6 p-2">
        {/* Uygulama Adı */}
        <div className="flex flex-col gap-2">
          <label>Uygulama Adı *</label>
          <InputText
            value={formData.name}
            onChange={(e) =>
              setFormData((p) => ({ ...p, name: e.target.value }))
            }
            placeholder="Örn: Mikro v16 Entegrasyonu"
          />
        </div>

        {/* Tip */}
        <div className="flex flex-col gap-2">
          <label>Entegrasyon Tipi *</label>
          <Dropdown
            value={formData.externalType}
            options={integrationTypeOptions}
            onChange={(e) =>
              setFormData((p) => ({
                ...p,
                externalType: e.value,
              }))
            }
            className="w-full"
          />
        </div>

        {/* Aktif */}
        <div className="flex items-center gap-2 pt-2">
          <Checkbox
            inputId="active"
            checked={formData.isActive}
            onChange={(e) =>
              setFormData((p) => ({ ...p, isActive: e.checked! }))
            }
          />
          <label htmlFor="active" className="cursor-pointer">
            Aktif Uygulama
          </label>
        </div>
      </div>
    </Dialog>
  );
};